<template>
    <div class="toolBox" ref="toolBox">
        <a-space>
            <a-button @click="print" type="primary" size="small">打印</a-button>
            <a-button @click="closeIframe" danger size="small">关闭</a-button>
        </a-space>
    </div>
    <div class="" ref="doprintcodepage">
        <a-table :data-source="tableData" bordered :pagination="false" :columns="columns" rowKey="id"
            class="after-repair-table">
            <template #afterSaleProblemDescription="{ record }">
                <div v-for="(item, index) in record.afterSaleProblemDescription.split('#')" :key="index">
                    {{ index + 1 }}：{{ item.value }}
                </div>
            </template>

            <template #picture="{ record }">
                <a-image-preview-group v-if="record.picture">
                    <a-image v-for="(item, index) in JSON.parse(record.picture)" :width="50" :key="index" :src="item" />
                </a-image-preview-group>
            </template>

            <template #recipient="{ record }">
                <div v-if="record.recipient">
                    {{ record.recipient.split(',')[0] }}
                </div>
            </template>

        </a-table>
    </div>
</template>

<script>
import { defineComponent, reactive, ref } from 'vue';

export default defineComponent({
    setup() {
        // 工具栏
        const toolBox = ref();
        const doprintcodepage = ref();
        // 打印前的操作
        const beforePrint = () => {
            doprintcodepage.value.style.overflow = "initial";
            toolBox.value.style.display = "none";
        };

        // 打印后的操作
        const afterPrint = () => {
            doprintcodepage.value.style.overflow = "scroll";
            toolBox.value.style.display = "flex";
        };

        window.onbeforeprint = beforePrint;
        window.onafterprint = afterPrint;

        const tableData = reactive([]);

        const init = () => {
            tableData.push(...JSON.parse(localStorage.getItem('qc_afterRepair_print')));
        }

        const columns = [
            { title: "id", dataIndex: "id", align: "center", width: "80px", },
            { title: "年度", dataIndex: "year", align: "center", width: "80px", },
            { title: "反馈日期", dataIndex: "feedbackDate", align: "center", width: "190px", },
            { title: "生产日期", dataIndex: "produceDate", align: "center", width: "120px", },
            { title: "设备型号", dataIndex: "model", align: "center", width: "125px", },
            { title: "机身号", dataIndex: "serial", align: "center", width: "160px", },
            { title: "问题现象", dataIndex: "problemPhenomenon", align: "center", width: "160px" },
            { title: "图片", dataIndex: "picture", align: "center", width: "150px", slots: { customRender: 'picture' } },
            // { title: "情况确认和分析", dataIndex: "confirmationAndAnalysis", align: "center", width: "175px" },
            // { title: "问题类型", dataIndex: "problemType", align: "center", width: "100px" },
            // { title: "接收人", align: "center", width: "100px", slots: { customRender: 'recipient' } },
            // { title: "根本原因分析", dataIndex: "rootCauseAnalysis", align: "center", width: "150px" },
            // { title: "临时措施", dataIndex: "temporaryMeasures", align: "center", width: "180px" },
            // { title: "闭环措施", dataIndex: "closedLoopMeasures", align: "center", width: "180px" },
            // { title: "执行措施", dataIndex: "implementationMeasures", align: "center", width: "180px" },
            // {
            //     title: '执行部门',
            //     children: [
            //         { title: "反馈部门", dataIndex: "feedbackDept", align: "center", width: "100px" },
            //         { title: "分析部门", dataIndex: "analysisDept", align: "center", width: "100px" },
            //         { title: "执行部门", dataIndex: "executionDept", align: "center", width: "100px" },
            //         { title: "监督部门", dataIndex: "supervisionDept", align: "center", width: "100px" },
            //     ]
            // },
            // { title: "状态", dataIndex: "status", align: "center", width: "120px" },
            // { title: "备注", dataIndex: "notes", align: "center", width: "160px" },
        ];


        init();

        const print = () => {
            window.print();
        };

        const closeIframe = () => {
            localStorage.removeItem("qc_afterRepair_print");
            window.parent.postMessage("closeIframe", "*");
        };

        return {
            print,
            doprintcodepage,
            closeIframe,
            toolBox,
            tableData,
            columns,
        };
    }
});
</script>

<style lang="less" scoped>
@page {
    size: landscape;
}

@media print {
    @page {
        margin: 0;
    }

    body {
        margin: 0;
        padding: 0;
    }

    html {
        margin: 0;
        padding: 0;
    }
}

.toolBox {
    padding: 20px;
}

.print-area {
    width: 1146px;
    padding: 0 40px;
}

.after-repair-table {
    width: 1146px;
}
</style>
